export class ASTNode {
    constructor(
        public readonly type: string,
        public operands: Array<any> = [],
        public children: Array<ASTNode> = []
    ) {}
}
